import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    root: {
      borderRadius: 6,
      background: "white",
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.12)",
      overflow: "hidden",
      height: "fit-content"
    },
    header: {
      padding: "1rem 1.6rem",
      background: theme.palette.gardient.medium,
      colors: "white",
      display: "flex",
      alignItems: "center"
    },
    titleHeader: {
      color: "white",
      margin: "0 6px"
    },
    customerBox: {
      paddingBottom: "1.6rem"
    },
    title: {
      textTransform: "uppercase",
      color: theme.palette.info.main
    },
    lighter: {
      fontWeight: "lighter"
    },
    boxInfo: {
      margin: "8px 0",
      padding: "10px 15px",
      background: theme.palette.background.default,
      borderRadius: 4,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    },
    infoName: {
      color: theme.palette.info.main
    },
    infoContent: {
      color: theme.palette.grey[900],
      marginLeft: "auto",
      "&.boldWeight": {
        fontWeight: "bold"
      }
    },
    customerInput: {
      padding: "5px 0 15px 0",
      margin: "10px 0 15px 0"
    },
    inputLabel: {
      marginBottom: 4,
      color: theme.palette.grey[900],
      fontSize: 14,
      fontWeight: 700
    },
    fullWidth: {
      width: "100%"
    },
    required: {
      color: theme.palette.error.main,
      marginLeft: 1,
      "& :after": {
        content: "*"
      }
    },
    textError: {
      color: theme.palette.error.light,
      marginTop: 5,
      fontSize: 12
    },
    inputField: {
      marginBottom: 15,
      "& .MuiOutlinedInput-adornedEnd": {
        paddingRight: "2rem"
      },
      "& [class*=SingleAutocompleteSelectField-adornment]": {
        marginTop: "5px"
      },
      "& .MuiInputBase-input": {
        padding: "12px 16px",
        fontSize: "1.4rem"
      },
      "& .MuiInputBase-input::placeholder": {
        fontSize: "1.4rem",
        color: theme.palette.grey[500]
      },
      "& .MuiSelect-root": {
        padding: "10px 16px"
      },
      "& .MuiFormControl-root": {
        width: "100%"
      }
    },
    customerConfirm: {
      padding: "5px 15px 15px 15px"
    },
    buttonApply: {
      padding: 10,
      width: "100%",
      maxWidth: 240,
      fontSize: 16,
      lineHeight: "24px",
      "& .MuiButton-label": {
        fontWeight: 700
      }
    },
    textFieldNoLabel: {},
    footer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      margin: "0 24px",
      padding: "24px 0",
      borderTop: `1px solid ${theme.palette.grey[400]}`
    },
    shippingAddress: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    },
    wrapContent: {
      padding: 24
    },
    wrapInfoMore: {
      backgroundColor: "#F2FAFB",
      padding: "12px 16px",
      borderRadius: 6
    },
    titleInfoMore: {
      marginBottom: 16,
      color: theme.palette.grey[900]
    },
    selectField: {
      "& .MuiSelect-root": {
        color: theme.palette.grey[900],
        fontSize: "1.4rem"
      }
    },
    labelAddress: {
      color: theme.palette.grey[900]
    },
    btnAddress: {
      fontSize: "1.4rem"
    },
    titleTextArea: {
      display: "flex",
      alignItems: "center",
      columnGap: "8px"
    },
    subTitleTextArea: {
      color: theme.palette.info.dark
    },
    selectItem: {
      fontWeight: "bold",
      display: "inline-block",
      marginRight: 5
    },
    radioGroup: {
      flexDirection: "row"
    },
    info: {
      color: theme.palette.info.main
    },
    flex: {
      display: "flex"
    },
    routerBtn: {
      order: 1,
      height: 38
    },
    routeSearch: {
      display: "flex",
      alignItems: "center",
      gap: 10
    }
  }),
  { name: "CustomerDataInfo" }
);

export default useStyles;
